import type { FC } from 'react';
import Modal from '@components/Modal';

type AboutModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

const AboutModal: FC<AboutModalProps> = ({ isOpen, onClose }) => {
  const title = process.env.REACT_APP_TITLE || '';

  return (
    <Modal opened={isOpen} title="About" onClose={onClose}>
      <p>
        Whiteshield- {title}© is the Intellectual Property
        of Whiteshield Partners. Any reports and deliverables generated using
        the above tool are the Intellectual Property of the respective Clients
        as per the agreement.
      </p>
      <p>
        For more information on the tool please contact{' '}
        <a href="mailto:info@whiteshieldpartners.com">Whiteshield</a>.
      </p>
    </Modal>
  );
};

export default AboutModal;
